export default __webpack_public_path__ + "475855007319abc5c88c529b7bc25390.png";